import { I18n } from '@calendly/i18n'

import { useScope } from 'hooks/meetings/use_scope'

import { DropdownFilter } from './dropdown/dropdown_filter'
import { FilterLayout } from './filter_layout'

export const EventTypesSelect = ({ params, onApply, useColumnLayout = false }) => {
  const { scopeType } = useScope()
  const controlText = params.event_type_ids.length === 0
    ? I18n.t('publisher.dashboard.filters.label.event_type_all')
    : I18n.t('publisher.dashboard.filters.label.event_type', { count: params.event_type_ids.length })

  const applySelectedIds = (valueSets) => {
    const values = Object.values(valueSets).flat()
    onApply({
      ...params,
      event_type_ids: values || []
    })
  }

  const buildShowMoreGroupsLabel = () => {
    switch (scopeType) {
      case 'users':
        return I18n.t('publisher.scheduled_events.filters.show_more_users')
      case 'all_users_and_teams':
        return I18n.t('publisher.scheduled_events.filters.show_more_users_and_teams')
      default:
        return I18n.t('publisher.scheduled_events.filters.show_more_teams')
    }
  }

  return (
    <FilterLayout
      label={I18n.t('publisher.labels.event_type')}
      useColumnLayout={useColumnLayout}
    >
      <DropdownFilter
        name="event_type"
        params={params}
        showHeader
        showSearchInput
        showSelectedItemGroup={scopeType !== 'team'}
        onApply={applySelectedIds}
        controlText={controlText}
        showMoreGroupsLabel={buildShowMoreGroupsLabel()}
      />
    </FilterLayout>
  )
}
